import React from "react";

export function Eyebrow({ children, tone = "dark" }) {
  return (
    <div className="flex items-center gap-3">
      <span
        className="h-[6px] w-[6px] rotate-45"
        style={{ background: "var(--gold)" }}
      />
      <span
        className="eyebrow"
        style={{ color: tone === "light" ? "var(--gold-200)" : "var(--gold)" }}
      >
        {children}
      </span>
    </div>
  );
}

export function SectionHeading({ eyebrow, title, sub, tone = "dark", align = "left", className = "" }) {
  const isLight = tone === "light";
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}
      data-reveal=""
    >
      {eyebrow && (
        <div className={align === "center" ? "flex justify-center" : ""}>
          <Eyebrow tone={tone}>{eyebrow}</Eyebrow>
        </div>
      )}
      <h2
        className="font-display mt-5 text-[2.1rem] leading-[1.1] tracking-tight sm:text-[2.9rem] lg:text-[3.4rem]"
        style={{ color: isLight ? "#FBF7F0" : "var(--teal-900)", fontWeight: 400 }}
      >
        {title}
      </h2>
      {sub && (
        <p
          className="mt-6 text-[1.02rem] leading-relaxed"
          style={{ color: isLight ? "rgba(251,247,240,.78)" : "var(--muted-ink)" }}
        >
          {sub}
        </p>
      )}
    </div>
  );
}
